import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { combineLatest, fromEvent, Observable, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, mapTo, takeUntil } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { ErrorService } from './error/err.service';
import { Crump, RoutecrumpsService } from './services/routecrumps.service';
import { CdkOverlyayService } from './shared/custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from './shared/custom-overlay/template-dropdown/template-dropdown.component';
import { ResetpwdComponent } from './user-login/reset-pwd/reset-pwd.component';
import { UserprofileComponent } from './user-login/userprofile/userprofile.component';
import { KeyValue } from '@angular/common';
import { SharedService } from './services/shared.service';
import { AsyncPipe } from '@angular/common';
import { HomeLandingService } from './home-landing/home-landing.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  
  title = 'Sauber';
  menu_array = [];
  // previewRef;
  offlineEvent: Observable<Event>
  subscriptions: Subscription[] = []
  onlineEvent: Observable<Event>
  footer: any;
  mat_spinner_userProfile_state: boolean;
  $destroy: Subject<boolean> = new Subject()
  alertShown = true
  UserInfo = ""
  categoryColums=[]
  constructor(private router: Router,
    public sharedService: SharedService,
    private authService: AuthService,
    public cdkoverlayDialog: CdkOverlyayService,
    public matdialog: MatDialog,
    private errorService: ErrorService,
    public crumpService: RoutecrumpsService,
    public homeLanderService:HomeLandingService
  ) { }

  ngOnInit(): void {
    
    this.router.navigateByUrl('login');
    this.offlineEvent = fromEvent(window, 'offline');
    this.onlineEvent = fromEvent(window, 'online');
    this.errorService.getErrorMetadata()

    this.subscriptions.push(this.offlineEvent.subscribe((e) => {
      this.errorService.userOffline(true)
    }))

    this.subscriptions.push(combineLatest([this.onlineEvent.pipe(mapTo(1)), this.sharedService.$userLogged])
      .subscribe((e) => {
        if (e[1]) {
          this.errorService.handleOfflineError()
        }
      }))

    this.sharedService.$metaData.subscribe(val => {
      this.footer = val.commonData.footer
    })
    
  }

  ngAfterViewInit(): void {
    
    window.addEventListener("keyup", disableF5);
    window.addEventListener("keydown", disableF5);

    function disableF5(e) {
      // console.log(e)
      if ((e.which || e.keyCode) == 116)
        e.preventDefault();
    };

    this.sharedService.getMenu().subscribe(val => {
      this.menu_array = val;
    })

    this.sharedService.$sidebarExpanded.pipe(distinctUntilChanged()).subscribe(val=>{
      if(!val){
        this.sharedService?.menu?.forEach(list=>{
          list.expand = true
        })
      }
    })
   
  }

  crump_click(crump: Crump, index: number) {
    if (index + 1 < this.crumpService.route_crumps.length) {
      for (let i = index + 1; i < this.crumpService.route_crumps.length; i++) {
        if (this.crumpService.route_crumps[i].callback && crump.isParent) {
          this.crumpService.route_crumps[i].callback.next(crump.disp_str);
        }
      }
      // this._service.$selectedDashboardLabel.next(crump.disp_str)
      this.router.navigateByUrl(crump.routeTo);
      
    }
  }

  homeIcon = {
    // img_url: "assets/menuicons/home.svg",
    img_url: "assets/overview.svg",
    label: "Home",
    url: "home",
    isSelectable: true,
    isSelected: true
  }

  openOverlay_click(template, origin): void {
    let config = {
      data: {
        "template": template,
      },
      // width: '15vw'
    }
    this.sharedService.previewRef = this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }

  async openMyProfile_click() {
    this.mat_spinner_userProfile_state = true;
    await this.sharedService.getUserProfile({ "user_name": this.sharedService.userName })
      .pipe(takeUntil(this.$destroy))
      .toPromise()
      .then((val) => {
        this.mat_spinner_userProfile_state = false;
        const dialogRef = this.matdialog.open(UserprofileComponent, {
          width: "48%",
          height: "78vh",
          data: { userProfile: val },
          autoFocus: false
        });
        dialogRef.afterClosed().subscribe((dat) => { })
        this.closePreview()
      })
  }

  openResetPassword_click() {
    let dialogRef = this.matdialog.open(ResetpwdComponent,
      {
        width: "50%",
        height: "50vh",
        data: {
          "header": "Reset Password Verification",
          "buttonLabels": ["Submit", "Cancel"]
        }, autoFocus: false
      }
    );
    dialogRef.afterClosed().subscribe((dat) => {
    });
    this.closePreview();
  }

  logout() {
//console.log("Log out click")
    this.authService.logout().subscribe(() => {
//console.log("Log out subscribe")
      this.sharedService.userName = null;
      this.router.navigateByUrl('login');
      this.removesessionStoragevalue();
      this.closePreview();
    }, (err) => {
      this.removesessionStoragevalue();
    })
  }
  openOrganization_click() {
    const flattenedObj = {...this.crumpService.applist};
    let data = []
    for(let category in flattenedObj){
      // console.log("category===",category,flattenedObj[category])
      for(let i=0;i<flattenedObj[category].length;i++){
        if(flattenedObj[category][i].url == 'organization'){
          data.push(flattenedObj[category][i])
        }
      }
    }
    // const filteredData = flattenedArray.filter(obj => obj.url == 'organization')
    // console.log("openOrganization_click=============",data)
    if(data.length>0){
      this.crumpService.homeIcon.isSelected = false
      this.crumpService.resetMenuList()
      data[0]['isSelected'] = true
      this.router.navigateByUrl(data[0]['url']);
      this.closePreview()
    }
    
  }
  removesessionStoragevalue() {
    if (sessionStorage.getItem('SPL')) {
      sessionStorage.removeItem('SPL')
    }
    if (sessionStorage.getItem('SRID')) {
      sessionStorage.removeItem('SRID')
    }
    if (sessionStorage.getItem('query_fields')) {
      sessionStorage.removeItem('query_fields')
    }
  }

  navIconclick(nav: any) {
//console.log('navIconclick',nav)
    if (nav.isSelectable && nav.url) {
      this.crumpService.homeIcon.isSelected = false
      this.crumpService.resetMenuList()
      this.sharedService.$selectedDashboardLabel.next(nav)
      nav['isSelected'] = true
      this.router.navigateByUrl(nav.url)

      this.sharedService.menu.forEach(key=>{
        key.list.forEach(items=>{
          if(items.value != nav.value){
            items.isSelected = false
          }
        })
      })
    }
  }

  closePreview() {
    if (this.sharedService.previewRef) {
      this.sharedService.previewRef?.close()
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  appReloaded() {
    // this.logout()
  }

  @HostListener('window:unload', ['$event'])
  appUnloaded() {
    // this.logout()
  }

  ngOnDestroy() {
    // console.log("destroy")
    // this.logout()
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }
  setTooltipStyle() {
    document.addEventListener('DOMContentLoaded', () => {
      const tooltips = document.querySelectorAll('.tooltip');

      tooltips.forEach(tooltip => {
        tooltip.addEventListener('mouseover', () => {
          const title = tooltip.getAttribute('data-title');
          const tooltipDiv = document.createElement('div');
          tooltipDiv.className = 'custom-tooltip';
          tooltipDiv.innerText = title;
          document.body.appendChild(tooltipDiv);

          const rect = tooltip.getBoundingClientRect();
          tooltipDiv.style.left = `${rect.left + window.scrollX + rect.width / 2}px`;
          tooltipDiv.style.top = `${rect.top + window.scrollY - tooltipDiv.offsetHeight}px`;

          tooltip.addEventListener('mousemove', (e) => {
            // tooltipDiv.style.left = `${e['pageX']}px`;
            // tooltipDiv.style.top = `${e['pageY'] - tooltipDiv.offsetHeight}px`;
          });

          tooltip.addEventListener('mouseout', () => {
            tooltipDiv.remove();
          });
        });
      });
    });
  }
  //unsort the key value from the array of objects
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  accordianClick(value){
    this.sharedService.menu.forEach(val=>{
      if(val.value == value){
        val.expand = !val.expand
      }
    })
  }
  collapseNav(){
    this.sharedService.sidebarState("")
  }

}